// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { SubscriptionLoaded, SubscriptionLoading } from '@actions/subscription';

interface SubscriptionData {
  [key: string]: unknown;
}

interface SubscriptionState {
  data: SubscriptionData | null;
  loading: boolean;
}

type SubscriptionPayload = SubscriptionData | null;

type SubscriptionAction = Action<SubscriptionPayload>;

const initialState: SubscriptionState = { data: null, loading: false };

export default handleActions<SubscriptionState, SubscriptionPayload>(
  {
    [SubscriptionLoading.toString()]: (
      _: SubscriptionState,
      { payload }: SubscriptionAction,
    ): SubscriptionState => ({
      data: payload,
      loading: true,
    }),
    [SubscriptionLoaded.toString()]: (
      _: SubscriptionState,
      { payload }: SubscriptionAction,
    ): SubscriptionState => ({
      data: payload,
      loading: false,
    }),
  },
  initialState,
);
